/** @jsx jsx */
/** @jsxFrag */
import { jsx } from '@emotion/react';
import React from 'react';
import theme from 'theme';

export interface BreadcrumbsProps {
  children?: React.ReactNode;
  separator?: string;
}

function Breadcrumbs({ children, separator = ' > ' }: BreadcrumbsProps): JSX.Element {
  const ch = React.Children.toArray(children).filter(Boolean);

  return (
    <div
      css={{
        '& > .active': {
          color: theme.palette.primary.main,
        },
        '& > a:hover': { textDecoration: 'underline' },
        '&, & > a': {
          '@media(min-width: 600px)': {
            fontSize: '.9em',
          },
          '@media(min-width: 960px)': {
            fontSize: '1em',
          },
          color: theme.palette.text.secondary,
          fontSize: '.8em',
          fontWeight: theme.typography.fontWeightRegular,
          outline: 'none',
          textDecoration: 'none',
          transition: 'all .2s ease',
        },
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
      }}
    >
      {ch.map((c, i) => (
        <React.Fragment key={i.toString()}>
          {c}
          {i < ch.length - 1 ? <span css={(theme) => ({ margin: theme.spacing(0, 0.5) })}>{separator}</span> : ''}
        </React.Fragment>
      ))}
    </div>
  );
}

Breadcrumbs.displayName = 'Breadcrumbs';

export default Breadcrumbs;
